module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<img src="' +
((__t = ( getImage() )) == null ? '' : __t) +
'">';

}
return __p
}